import i18next from "i18next";
import capitalize from "lodash/capitalize";
import filtersStorage from "../storages/filtersStorage";
import Core from "../core/Core";

export function generateH1CatWothoutFilters(fixedH1, categoryTexts, pageTitle) {
  if (fixedH1) return fixedH1;
  const h1 = categoryTexts.h1 || pageTitle;
  return h1;
}

export function generateH1Cat(fixedH1, categoryTexts, pageTitle) {
  if (fixedH1) return fixedH1;
  const structure = Core.routing.parseRoute(window.location);
  let h1 = categoryTexts.h1 || pageTitle;
  if (structure.brands) {
    h1 += ` ${Object.keys(filtersStorage.currentFilters.brands)
      .filter((v) => v)
      .join(", ")}`;
  }
  if (
    structure.size ||
    structure.vgroup ||
    structure.seasons ||
    structure.group ||
    structure.cities
  )
    h1 += ":";
  const additionalH1 = [];
  if (structure.size) {
    additionalH1.push(
      ` р/р ${Object.keys(filtersStorage.currentFilters.sizes)
        .filter((v) => v)
        .join(", ")}`
    );
  }
  if (structure.seasons) {
    additionalH1.push(
      ` ${i18next.t("season")} - ${Object.keys(
        filtersStorage.currentFilters.seasons
      )
        .filter((v) => v)
        .map((name) => i18next.t(name))
        .join(", ")}`
    );
  }
  if (structure.vgroup) {
    additionalH1.push(
      ` ${i18next.t("Age")} - ${Object.keys(
        filtersStorage.currentFilters.vgroup
      )
        .filter((v) => v)
        .map((name) => i18next.t(name))
        .join(", ")}`
    );
  }
  if (structure.group) {
    additionalH1.push(
      ` ${i18next.t("group")} - ${Object.keys(
        filtersStorage.currentFilters.group
      )
        .filter((v) => v)
        .map((name) => i18next.t(name)?.toLowerCase())
        .join(", ")}`
    );
  }
  if (structure.cities) {
    additionalH1.push(
      ` ${i18next.t("city")} - ${Object.keys(
        filtersStorage.currentFilters.cities
      )
        .filter((v) => v)
        .map((name) => capitalize(i18next.t(name)?.toLowerCase()))
        .join(", ")}`
    );
  }
  if (additionalH1.length > 0) {
    h1 += ` ${additionalH1.join(", ")}`;
  }
  // if (currentPage) {
  //   currentPage = +currentPage;
  // }
  return h1;
}

export function generateH1Detail(fixedH1, altH1) {
  if (fixedH1) return fixedH1;
  return altH1;
}

// export default {
//   generateH1Cat,
//   generateH1Detail,
// };
